export type ValXmlSimpleTypeInfo = {
    base?: string
    enumeration?: string[]
}

export type ValXmlAttributeDefinition = {
    path: string
    name: string
    baseType?: string
    typeRef?: string
    documentation?: string
    simpleType?: ValXmlSimpleTypeInfo
}

export const VALXML_ATTRIBUTE_DEFINITIONS: ValXmlAttributeDefinition[] = [
    {
        path: 'BIISValuationData.General.Address.Country',
        name: 'Country',
        baseType: 'xs:string',
        typeRef: 'ISOCountryCodeType',
        simpleType: {
            base: 'xs:string',
        },
        documentation: 'Die Landeskennzahl einer Adresse, dargestellt als ISO-Landescode.',
    },
    {
        path: 'BIISValuationData.General.Address.PostCode',
        name: 'PostCode',
        baseType: 'xs:string',
        documentation: 'Die Postleitzahl einer Adresse.',
    },
    {
        path: 'BIISValuationData.General.Address.Street',
        name: 'Street',
        baseType: 'xs:string',
        documentation: 'Die Strasse einer Adresse.',
    },
    {
        path: 'BIISValuationData.General.Address.Town',
        name: 'Town',
        baseType: 'xs:string',
        documentation: 'Der Ort einer Adresse.',
    },
    {
        path: 'BIISValuationData.General.ObjNoOwner',
        name: 'ObjNoOwner',
        baseType: 'xs:string',
        documentation: 'Objektnummer/Objekt-Referenz des Eigentuemers',
    },
    {
        path: 'BIISValuationData.General.ObjNoOwnerTechnical',
        name: 'ObjNoOwnerTechnical',
        baseType: 'xs:string',
        documentation: 'zusätzliche Objektnummer/Objekt-Referenz des Eigentuemers zur Datenverarbeitung',
    },
    {
        path: 'BIISValuationData.General.Owner',
        name: 'Owner',
        baseType: 'xs:string',
        documentation: 'Eigentuemer des Objekts',
    },
    {
        path: 'BIISValuationData.General.PortfolioName',
        name: 'PortfolioName',
        baseType: 'xs:string',
        documentation: 'Name des Portfolios, Fonds bzw. Sondervermoegens, dessen Teil die Immobilie ist',
    },
    {
        path: 'BIISValuationData.ValuationResults.AncillaryTypeOfUse',
        name: 'AncillaryTypeOfUse',
        baseType: 'xs:string',
        simpleType: {
            base: 'xs:string',
            enumeration: [
                'Buero',
                'Handel',
                'Industrie(Lager,Hallen)',
                'Keller/Archiv',
                'Gastronomie',
                'Hotel',
                'Wohnen',
                'Freizeit',
                'Soziales',
                'GewerbeAllgemein',
                'Garage/TG',
                'Aussenstellplaetze',
                'unbekannt',
            ],
        },
        documentation:
            'Nebennutzungsart im Objekt. Zulaessig sind Buero, Handel, Industrie(Lager,Hallen), Keller/Archiv, Gastronomie, Hotel, Wohnen, Freizeit, Soziales, GewerbeAllgemein, Garage/TG, Aussenstellplaetze, unbekannt',
    },
    {
        path: 'BIISValuationData.ValuationResults.CalculatedYearOfConstruction',
        name: 'CalculatedYearOfConstruction',
        baseType: 'xs:integer',
        documentation: 'Wirtschaftliches Baujahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.CapitalizationRate',
        name: 'CapitalizationRate',
        baseType: 'xs:decimal',
        documentation: 'Liegenschaftszinssatz',
    },
    {
        path: 'BIISValuationData.ValuationResults.CoValuer1Name',
        name: 'CoValuer1Name',
        baseType: 'xs:string',
        documentation: 'Name des 1. Nebengutachters',
    },
    {
        path: 'BIISValuationData.ValuationResults.CoValuer2Name',
        name: 'CoValuer2Name',
        baseType: 'xs:string',
        documentation: 'Name des 2. Nebengutachters',
    },
    {
        path: 'BIISValuationData.ValuationResults.CostApproach',
        name: 'CostApproach',
        baseType: 'xs:decimal',
        documentation: 'Ergebnis des Sachwertverfahrens',
    },
    {
        path: 'BIISValuationData.ValuationResults.DateOfAppraisal',
        name: 'DateOfAppraisal',
        baseType: 'xs:date',
        documentation: 'Wertermittlungs-Stichtag',
    },
    {
        path: 'BIISValuationData.ValuationResults.FitOutQuality',
        name: 'FitOutQuality',
        baseType: 'xs:string',
        simpleType: {
            base: 'xs:string',
            enumeration: ['stark gehoben', 'gehoben', 'mittel', 'einfach', '(unbekannt)'],
        },
        documentation: 'Qualität der Ausstattung: stark gehoben, gehoben, mittel, einfach oder (unbekannt)',
    },
    {
        path: 'BIISValuationData.ValuationResults.FloorToAreaRatio',
        name: 'FloorToAreaRatio',
        baseType: 'xs:double',
        documentation: 'Geschossflächenzahl',
    },
    {
        path: 'BIISValuationData.ValuationResults.Floors',
        name: 'Floors',
        baseType: 'xs:string',
        documentation: 'Anzahl/Beschreibung der Geschosse',
    },
    {
        path: 'BIISValuationData.ValuationResults.LandSize',
        name: 'LandSize',
        baseType: 'xs:decimal',
        documentation: 'Grundstuecksgröße in Gutachten-flächeneinheit',
    },
    {
        path: 'BIISValuationData.ValuationResults.LandValue',
        name: 'LandValue',
        baseType: 'xs:decimal',
        documentation: 'Bodenwert',
    },
    {
        path: 'BIISValuationData.ValuationResults.LocationQuality',
        name: 'LocationQuality',
        baseType: 'xs:string',
        simpleType: {
            base: 'xs:string',
            enumeration: ['1a', '1b', '2a', '2b', '3', '(unbekannt)'],
        },
        documentation: 'Lagequalität: 1a, 1b, 2a, 2b, 3 oder (unbekannt)',
    },
    {
        path: 'BIISValuationData.ValuationResults.MainTypeOfUse',
        name: 'MainTypeOfUse',
        baseType: 'xs:string',
        simpleType: {
            base: 'xs:string',
            enumeration: [
                'Buero',
                'Handel',
                'Industrie(Lager,Hallen)',
                'Keller/Archiv',
                'Gastronomie',
                'Hotel',
                'Wohnen',
                'Freizeit',
                'Soziales',
                'GewerbeAllgemein',
                'Garage/TG',
                'Aussenstellplaetze',
                'unbekannt',
            ],
        },
        documentation:
            'Hauptnutzungsart im Objekt. Zulaessig sind Buero, Handel, Industrie(Lager,Hallen), Keller/Archiv, Gastronomie, Hotel, Wohnen, Freizeit, Soziales, GewerbeAllgemein, Garage/TG, Aussenstellplaetze, unbekannt',
    },
    {
        path: 'BIISValuationData.ValuationResults.MainValuerDateOfInspection',
        name: 'MainValuerDateOfInspection',
        baseType: 'xs:date',
        documentation: 'Tag der Ortsbesichtigung des Hauptgutachters',
    },
    {
        path: 'BIISValuationData.ValuationResults.MainValuerName',
        name: 'MainValuerName',
        baseType: 'xs:string',
        documentation: 'Name des Hauptgutachters',
    },
    {
        path: 'BIISValuationData.ValuationResults.MaintenanceExpenses',
        name: 'MaintenanceExpenses',
        baseType: 'xs:decimal',
        documentation: 'Instandhaltungskosten, Absolutbetrag in Gutachtenwährung',
    },
    {
        path: 'BIISValuationData.ValuationResults.ManagementCosts',
        name: 'ManagementCosts',
        baseType: 'xs:decimal',
        documentation: 'Verwaltungskosten, Absolutbetrag in Gutachtenwährung',
    },
    {
        path: 'BIISValuationData.ValuationResults.MarketValue',
        name: 'MarketValue',
        baseType: 'xs:decimal',
        documentation: 'Verkehrswert',
    },
    {
        path: 'BIISValuationData.ValuationResults.NormalTotalEconomicLife',
        name: 'NormalTotalEconomicLife',
        baseType: 'xs:integer',
        documentation: 'Gesamtnutzungsdauer',
    },
    {
        path: 'BIISValuationData.ValuationResults.OriginalYearOfConstructionAsYearNumber',
        name: 'OriginalYearOfConstructionAsYearNumber',
        baseType: 'xs:integer',
        documentation: 'Ursprungsbaujahr (des ältesten Baukörpers des Objekts) als 4-stellige Jahreszahl',
    },
    {
        path: 'BIISValuationData.ValuationResults.OtherOperatingExpenses',
        name: 'OtherOperatingExpenses',
        baseType: 'xs:decimal',
        documentation: 'Sonstige Bewirtschaftungskosten, Absolutbetrag in Gutachtenwährung',
    },
    {
        path: 'BIISValuationData.ValuationResults.PriceOfSale',
        name: 'PriceOfSale',
        baseType: 'xs:decimal',
        documentation: 'Verkaufspreis in Gutachten',
    },
    {
        path: 'BIISValuationData.ValuationResults.PurchasePrice',
        name: 'PurchasePrice',
        baseType: 'xs:decimal',
        documentation: 'Ankaufspreis in Gutachtenwährung',
    },
    {
        path: 'BIISValuationData.ValuationResults.QualityDateOfAppraisalAsDate',
        name: 'QualityDateOfAppraisalAsDate',
        baseType: 'xs:date',
        documentation: 'Qualitätsstichtag der Wertermittlung als Datumsangabe',
    },
    {
        path: 'BIISValuationData.ValuationResults.RemainingEconomicLife',
        name: 'RemainingEconomicLife',
        baseType: 'xs:decimal',
        documentation: 'Restnutzungsdauer',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentAllowance',
        name: 'RentAllowance',
        baseType: 'xs:decimal',
        documentation: 'Mietausfallwagnis, Absolutbetrag in Gutachtenwährung',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationArchiveContractualAnnualRent',
        name: 'RentalSituationArchiveContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Archiv Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationArchiveEstimatedAnnualRentForLetArea',
        name: 'RentalSituationArchiveEstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Archiv Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationArchiveEstimatedAnnualRentForVacantArea',
        name: 'RentalSituationArchiveEstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Archiv Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationArchiveLetArea',
        name: 'RentalSituationArchiveLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Archiv Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationArchiveVacantArea',
        name: 'RentalSituationArchiveVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Archiv Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationBusinessGeneralContractualAnnualRent',
        name: 'RentalSituationBusinessGeneralContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gewerbe Allgemein Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationBusinessGeneralEstimatedAnnualRentForLetArea',
        name: 'RentalSituationBusinessGeneralEstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gewerbe Allgemein Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationBusinessGeneralEstimatedAnnualRentForVacantArea',
        name: 'RentalSituationBusinessGeneralEstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gewerbe Allgemein Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationBusinessGeneralLetArea',
        name: 'RentalSituationBusinessGeneralLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gewerbe Allgemein Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationBusinessGeneralVacantArea',
        name: 'RentalSituationBusinessGeneralVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gewerbe Allgemein Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationGastroContractualAnnualRent',
        name: 'RentalSituationGastroContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gastro Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationGastroEstimatedAnnualRentForLetArea',
        name: 'RentalSituationGastroEstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gastro Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationGastroEstimatedAnnualRentForVacantArea',
        name: 'RentalSituationGastroEstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gastro Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationGastroLetArea',
        name: 'RentalSituationGastroLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gastro Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationGastroVacantArea',
        name: 'RentalSituationGastroVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Gastro Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationHotelContractualAnnualRent',
        name: 'RentalSituationHotelContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Hotel Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationHotelEstimatedAnnualRentLet',
        name: 'RentalSituationHotelEstimatedAnnualRentLet',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Hotel Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationHotelEstimatedAnnualRentVacant',
        name: 'RentalSituationHotelEstimatedAnnualRentVacant',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Hotel Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationHotelLetArea',
        name: 'RentalSituationHotelLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Hotel Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationHotelLetNumbers',
        name: 'RentalSituationHotelLetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Hotel Vermietet Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationHotelVacantArea',
        name: 'RentalSituationHotelVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Hotel Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationHotelVacantNumbers',
        name: 'RentalSituationHotelVacantNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Hotel Leerstand Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationIndoorparkingContractualAnnualRent',
        name: 'RentalSituationIndoorparkingContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeInnen Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationIndoorparkingEstimatedAnnualRentForLetNumbers',
        name: 'RentalSituationIndoorparkingEstimatedAnnualRentForLetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeInnen Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationIndoorparkingEstimatedAnnualRentForVacantNumbers',
        name: 'RentalSituationIndoorparkingEstimatedAnnualRentForVacantNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeInnen Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationIndoorparkingLetNumbers',
        name: 'RentalSituationIndoorparkingLetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeInnen Vermietet Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationIndoorparkingVacantNumbers',
        name: 'RentalSituationIndoorparkingVacantNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeInnen Leerstand Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationLeisureContractualAnnualRent',
        name: 'RentalSituationLeisureContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Freizeit Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationLeisureEstimatedAnnualRentForLetArea',
        name: 'RentalSituationLeisureEstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Freizeit Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationLeisureEstimatedAnnualRentForVacantArea',
        name: 'RentalSituationLeisureEstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Freizeit Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationLeisureLetArea',
        name: 'RentalSituationLeisureLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Freizeit Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationLeisureVacantArea',
        name: 'RentalSituationLeisureVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Freizeit Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea1ContractualAnnualRent',
        name: 'RentalSituationMiscArea1ContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen1 Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea1EstimatedAnnualRentForLetArea',
        name: 'RentalSituationMiscArea1EstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen1 Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea1EstimatedAnnualRentForVacantArea',
        name: 'RentalSituationMiscArea1EstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen1 Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea1LetArea',
        name: 'RentalSituationMiscArea1LetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen1 Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea1VacantArea',
        name: 'RentalSituationMiscArea1VacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen1 Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea2ContractualAnnualRent',
        name: 'RentalSituationMiscArea2ContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen2 Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea2EstimatedAnnualRentForLetArea',
        name: 'RentalSituationMiscArea2EstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen2 Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea2EstimatedAnnualRentForVacantArea',
        name: 'RentalSituationMiscArea2EstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen2 Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea2LetArea',
        name: 'RentalSituationMiscArea2LetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen2 Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscArea2VacantArea',
        name: 'RentalSituationMiscArea2VacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Sonstigeflächen2 Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers1ContractualAnnualRent',
        name: 'RentalSituationMiscnumbers1ContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl1 Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers1EstimatedAnnualRentForLetNumbers',
        name: 'RentalSituationMiscnumbers1EstimatedAnnualRentForLetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl1 Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers1EstimatedAnnualRentForVacantNumbers',
        name: 'RentalSituationMiscnumbers1EstimatedAnnualRentForVacantNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl1 Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers1LetNumbers',
        name: 'RentalSituationMiscnumbers1LetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl1 Vermietet Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers1VacantNumbers',
        name: 'RentalSituationMiscnumbers1VacantNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl1 Leerstand Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers2ContractualAnnualRent',
        name: 'RentalSituationMiscnumbers2ContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl2 Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers2EstimatedAnnualRentForLetNumbers',
        name: 'RentalSituationMiscnumbers2EstimatedAnnualRentForLetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl2 Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers2EstimatedAnnualRentForVacantNumbers',
        name: 'RentalSituationMiscnumbers2EstimatedAnnualRentForVacantNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl2 Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers2LetNumbers',
        name: 'RentalSituationMiscnumbers2LetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl2 Vermietet Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationMiscnumbers2VacantNumbers',
        name: 'RentalSituationMiscnumbers2VacantNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: SonstigeAnzahl2 Leerstand Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOfficeContractualAnnualRent',
        name: 'RentalSituationOfficeContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Büro Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOfficeEstimatedAnnualRentForLetArea',
        name: 'RentalSituationOfficeEstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Büro Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOfficeEstimatedAnnualRentForVacantArea',
        name: 'RentalSituationOfficeEstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Büro Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOfficeLetArea',
        name: 'RentalSituationOfficeLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Büro Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOfficeVacantArea',
        name: 'RentalSituationOfficeVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Büro Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOutsideparkingContractualAnnualRent',
        name: 'RentalSituationOutsideparkingContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeAussen Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOutsideparkingEstimatedAnnualRentForLetNumbers',
        name: 'RentalSituationOutsideparkingEstimatedAnnualRentForLetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeAussen Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOutsideparkingEstimatedAnnualRentForVacantNumbers',
        name: 'RentalSituationOutsideparkingEstimatedAnnualRentForVacantNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeAussen Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOutsideparkingLetNumbers',
        name: 'RentalSituationOutsideparkingLetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeAussen Vermietet Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationOutsideparkingVacantNumbers',
        name: 'RentalSituationOutsideparkingVacantNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: StellplaetzeAussen Leerstand Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationResidentialContractualAnnualRent',
        name: 'RentalSituationResidentialContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Wohnen Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationResidentialEstimatedAnnualRentForLetArea',
        name: 'RentalSituationResidentialEstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Wohnen Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationResidentialEstimatedAnnualRentForVacantArea',
        name: 'RentalSituationResidentialEstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Wohnen Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationResidentialLetArea',
        name: 'RentalSituationResidentialLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Wohnen Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationResidentialVacantArea',
        name: 'RentalSituationResidentialVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Wohnen Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationRetailContractualAnnualRent',
        name: 'RentalSituationRetailContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Handel Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationRetailEstimatedAnnualRentForLetArea',
        name: 'RentalSituationRetailEstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Handel Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationRetailEstimatedAnnualRentForVacantArea',
        name: 'RentalSituationRetailEstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Handel Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationRetailLetArea',
        name: 'RentalSituationRetailLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Handel Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationRetailVacantArea',
        name: 'RentalSituationRetailVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Handel Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationSocialContractualAnnualRent',
        name: 'RentalSituationSocialContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Soziales Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationSocialEstimatedAnnualRentLet',
        name: 'RentalSituationSocialEstimatedAnnualRentLet',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Soziales Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationSocialEstimatedAnnualRentVacant',
        name: 'RentalSituationSocialEstimatedAnnualRentVacant',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Soziales Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationSocialLetArea',
        name: 'RentalSituationSocialLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Soziales Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationSocialLetNumbers',
        name: 'RentalSituationSocialLetNumbers',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Soziales Vermietet Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationSocialVacantArea',
        name: 'RentalSituationSocialVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Soziales Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationSocialVacantNumbers',
        name: 'RentalSituationSocialVacantNumbers',

        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Soziales Leerstand Stueck',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationStorageContractualAnnualRent',
        name: 'RentalSituationStorageContractualAnnualRent',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Lager Vermietet Vertragsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationStorageEstimatedAnnualRentForLetArea',
        name: 'RentalSituationStorageEstimatedAnnualRentForLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Lager Vermietet Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationStorageEstimatedAnnualRentForVacantArea',
        name: 'RentalSituationStorageEstimatedAnnualRentForVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Lager Leerstand Bewertungsmiete pro Jahr',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationStorageLetArea',
        name: 'RentalSituationStorageLetArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Lager Vermietet fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RentalSituationStorageVacantArea',
        name: 'RentalSituationStorageVacantArea',
        baseType: 'xs:decimal',
        documentation: 'Mietaufstellung: Lager Leerstand fläche',
    },
    {
        path: 'BIISValuationData.ValuationResults.RunningCosts',
        name: 'RunningCosts',
        baseType: 'xs:decimal',
        documentation: 'nicht umlagefaehige Betriebskosten, Absolutbetrag in Gutachtenwährung',
    },
    {
        path: 'BIISValuationData.ValuationResults.ShareAncillaryTypeOfUse',
        name: 'ShareAncillaryTypeOfUse',
        baseType: 'xs:decimal',
        typeRef: 'PercentageType',
        simpleType: {
            base: 'xs:decimal',
        },
        documentation: 'prozentualer Anteil der ersten Nebennutzung (Ertraege)',
    },
    {
        path: 'BIISValuationData.ValuationResults.ShareMainTypeOfUse',
        name: 'ShareMainTypeOfUse',
        baseType: 'xs:decimal',
        typeRef: 'PercentageType',
        simpleType: {
            base: 'xs:decimal',
        },
        documentation: 'prozentualer Anteil der Hauptnutzung (Ertraege)',
    },
    {
        path: 'BIISValuationData.ValuationResults.SiteCoverageRatio',
        name: 'SiteCoverageRatio',
        baseType: 'xs:decimal',
        documentation: 'Grundflächenzahl',
    },
    {
        path: 'BIISValuationData.ValuationResults.StateOfCompletion',
        name: 'StateOfCompletion',
        baseType: 'xs:string',
        simpleType: {
            base: 'xs:string',
            enumeration: ['F', 'I', 'P', '0'],
        },
        documentation: 'Grad der Fertigstellung: F=fertiggestellt, I=in Fertigstellung, P=in Planung, 0=(unbekannt)',
    },
    {
        path: 'BIISValuationData.ValuationResults.StructuralCondition',
        name: 'StructuralCondition',
        baseType: 'xs:string',
        simpleType: {
            base: 'xs:string',
            enumeration: ['sehr gut', 'gut', 'durchschnittlich', 'schlecht', '(unbekannt)'],
        },
        documentation: 'Zustand der baulichen Anlagen: sehr gut, gut, durchschnittlich, schlecht oder (unbekannt)',
    },
    {
        path: 'BIISValuationData.ValuationResults.TotalGrossFloorSpace',
        name: 'TotalGrossFloorSpace',
        baseType: 'xs:decimal',
        documentation: 'Bruttogrundfläche gesamt in Gutachten-flächeneinheit',
    },
    {
        path: 'BIISValuationData.ValuationResults.TotalRentableArea',
        name: 'TotalRentableArea',
        baseType: 'xs:decimal',
        documentation: 'Nutzfläche Gesamt in Gutachten-flächeneinheit',
    },
    {
        path: 'BIISValuationData.ValuationResults.TypeOfOwnership',
        name: 'TypeOfOwnership',
        baseType: 'xs:integer',
        documentation:
            'Eigentumsverhältnisse: 0=unbekannt, 1=Dingliches Nutzungsrecht, 2=Erbbaurecht, 3=gemischte Eigentumsform, 4=Teileigentum, 5=Volleigentum, 6=Volumeneigentum',
    },
    {
        path: 'BIISValuationData.ValuationResults.ValueByIncomeApproach',
        name: 'ValueByIncomeApproach',
        baseType: 'xs:decimal',
        documentation: 'Ergebnis des Ertragswertverfahrens, inklusive Sonderwerte',
    },
    {
        path: 'BIISValuationData.ValuationResults.ValueByIncomeApproachWithoutPremiumsDiscounts',
        name: 'ValueByIncomeApproachWithoutPremiumsDiscounts',
        baseType: 'xs:decimal',
        documentation: 'Ertragswert aus marktueblichen Ertraegen, ohne Beruecksichtigung von Sonderwerten',
    },
    {
        path: 'BIISValuationData.ValuationResults.YearOfLatestMajorRenovation',
        name: 'YearOfLatestMajorRenovation',
        baseType: 'xs:integer',
        documentation: 'Jahr der letzten umfangreichen Modernisierungs- oder Erweiterungsmassnahmen als 4-stellige Jahreszahl',
    },
    {
        path: 'DataSupplier.Short',
        name: 'Short',
        documentation: 'Name des Datenlieferanten bzw. -bezieher.',
    },
]
